import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color: string;
}

export const AttributeRequiredIndicator = ({ color }: Props) => {
  return <Box sx={{ width: '0.5rem', height: '0.5rem', borderRadius: '100%', backgroundColor: color }} />;
};
